import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import ImagePage from "@app/components/pageTypes/ImagePage/ImagePage"
import AnimatedRoute, { AnimationTypes } from "@app/components/routing/AnimatedRoute/AnimatedRoute"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useConfirmAccount } from "@app/store/service/connectorService"
import tracking from "@app/utils/tracking"
import { useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useCallback, useEffect } from "react"
import { useForm } from "react-hook-form"

const ConfirmAccount = () => {
	const verificationToken = useSelector("core.verificationToken")
	const verificationCode = useSelector("core.verificationCode")

	const { sm, md } = useViewport()
	const { replace } = useCustomNavigation()
	const raiseError = useRaiseError()

	const [confirmAccount, { isLoading }] = useConfirmAccount()
	const {
		data: { labelCode, confirmAccountPageTitle, errorMessages, buttonActivateAccount },
	} = useGetStrings(undefined, { defaultData: {} })

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: "onSubmit",
		defaultValues: {
			code: verificationCode || "",
		},
	})

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const submit = useCallback(async () => {
		handleSubmit(async data => {
			try {
				let result = await confirmAccount({ confirmationCode: data.code, token: verificationToken }).unwrap()
				result && tracking.signUpComplete()
				result && replace("/myParadise?action=verifiedAccount", AnimationTypes.stack, null, "pop")
			} catch (e) {
				raiseError(e)
			}
		})()
	})

	//Submit if we have a token and the strings are loaded
	useEffect(() => {
		if (verificationCode && errorMessages) {
			submit()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [errorMessages])

	return (
		<AnimatedRoute className="h-100">
			<ImagePage>
				<ContentHeader
					canGoBack
					colorStyle="white"
					animation={AnimationTypes.stack}
					customReturnFunction={() => {
						replace("/login", AnimationTypes.slide, null, "POP")
					}}
				>
					{confirmAccountPageTitle}
				</ContentHeader>
				<ContentBody className="container-md f4 mt-6">
					<Input
						name="ConfirmationCode"
						type="text"
						label={labelCode}
						formRegister={register("code", {
							required: {
								value: true,
								message: "Really required",
							},
						})}
						className="primary"
						errors={errors}
					/>
					<div className={"mt-4" + (sm || md ? " flex" : "")}>
						<Button style="primary" onClick={submit} fillWidth={sm || md} isLoading={isLoading}>
							{buttonActivateAccount}
						</Button>
					</div>
				</ContentBody>
			</ImagePage>
		</AnimatedRoute>
	)
}

export default ConfirmAccount
